import React from 'react';
import CustomerReviews from '../CustomerReviews/CustomerReviews';
import HeaderBody from '../HeaderBody/HeaderBody';

const Home = () => {
    return (
        <div>
            <HeaderBody></HeaderBody>
            <CustomerReviews></CustomerReviews>
        </div>
    );
};

export default Home;